import { LOCATION_CHANGE } from 'react-router-redux';

export default (state = {}, action) => {
	switch (action.type){
		case LOCATION_CHANGE: {
	      return {};
	    }
		case 'MAINTENANCE':
			return {
				...state,
				inProgress: false,
				errors: action.errors ? action.payload.errors : null
			};
			break;
		case 'ASYNC_START':
			if(action.subtype === 'MAINTENANCE') {
				return {...state,inProgress: true};
			}
			break;
		case 'UPDATE_FIELD':
	      return { ...state, [action.key]: [action.value] };
	    case 'UPDATE_FILE':
	      return { ...state, [action.key]:[...state.files,action.value] };
	      break;
	    case 'UPDATE_URL':
	      return { ...state, [action.key]:[...state.filesUrl,action.value] };
	      break;
	   case 'DELETE_FILE_URL':
	   	  return { ...state, 
	   	  	[action.key]:[
	   	  	...state.filesUrl.slice(0,action.value),
	   	  	...state.filesUrl.slice(action.value + 1)
	   	  	]
	   	  }
	   	  break;
	   	case 'CLEAR':
	   		return {...state, maintenance: null};
	   		break;
	   	case 'DELETE_FILE':
	   	  return { ...state, 
	   	  	[action.key]:[
	   	  	...state.files.slice(0,action.value),
	   	  	...state.files.slice(action.value + 1)
	   	  	]
	   	  }
	   	  break;
		default:
			return state;
		}
		return state;
};


// WEBPACK FOOTER //
// ./src/reducers/maintenance.js